import { Outlet } from '@tanstack/react-router';

export const RootLayout = () => <Outlet />;
